import api from './api';

export interface PublicService {
  id: string;
  title: string;
  icon: string;
  iconBrand: boolean;
  imageUrl?: string;
  description: string;
  features: string[];
  order: number;
  isPublished: boolean;
}

export const servicesService = {
  async getAll(): Promise<PublicService[]> {
    try {
      const response = await api.get('/services');
      const data = response.data?.data ?? response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Failed to fetch services:', error);
      return [];
    }
  },
};
